import Vue from 'vue';
import Router from 'vue-router';

import Home from './views/template/Home.vue';
import About from './views/template/About.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/manifest',
      name: 'manifest',
      component: () => import('./views/manifest/AppManifest.vue')
    },
    {
      path: '/faq/:idFaq',
      name: 'faq',
      component: () => import('./views/faq-portal-api/Faq.vue')
    },
    {
      path: '/carga-catalogo',
      name: 'carga-catalogo',
      component: () => import('./views/carga-catalogo/CargaCatalogo.vue')
    },
    {
      path: '/cadastro-portal-api',
      name: 'cadastro-portal-api',
      component: () => import('./views/cadastro-portal-api/Cadastro.vue'),
    },
    {
      path: '/fluxo-alternativo',
      name: 'fluxoAlternativo',
      component: () => import('./views/fluxo-alternativo/FluxoAlternativo.vue'),
    },
    {
      path: '/catalogo-api/:grupo/:nome',
      name: 'catalogo-api',
      component: () => import('./views/catalogo-api/Template-Principal.vue'),
      props: true
    },
    {
      path: '/catalogo-api/:grupo/:nome/:portal',
      name: 'catalogo-api-portal',
      component: () => import('./views/catalogo-api/Template-Principal.vue'),
      props: true
    },
    {
      path: '/configuracao-integracoes',
      name: 'configuracao-integracoes',
      component: () => import('./views/configuracao-integracoes/ConfiguracaoIntegracoes.vue')
    },    
    {
      path: '/consulta-integracoes',
      name: 'consulta-integracoes',
      component: () => import('./views/consulta-integracoes/Consulta.vue'),
    },
    {
      path: '/fluxo-integracoes',
      name: 'fluxo-integracoes',
      component: () => import('./views/fluxo/Fluxo.vue')
    },
    {
      path: '/pagina-construcao',
      name: 'pagina-construcao',
      component: () => import('./views/pagina-construcao/PaginaConstrucao.vue')
    },
    {
      path: '/consulta-catalogo',
      name: 'consulta-catalogo',
      component: () => import('./views/consulta-catalogo-api/ConsultaCatalago.vue')
    },
    {
      path: '/manutencao-catalogo-servico/:idCatalogo',
      name: 'manutencao-catalogo-servico',
      component: () => import('./views/manutencao-catalogo-servico/ManutencaoCatalogoServico.vue')
    },
    {
      path: '/log-ws',
      name: 'log-ws',
      component: () => import('./views/log-ws/Log.vue')
    },
    {
      path: '/dashboard-portal-api',
      name: 'dashboard-portal-api',
      component: () => import('./views/dashboard-portal-api/DashboardPortalApi.vue')
    },
    {
      path: '/suporte-portal-api',
      name: 'suporte-portal-api',
      component: () => import('./views/suporte-portal-api/Suporte.vue')
    },
    {
      path: '/nova-notificacao',
      name: 'nova-notificacao',
      component: () => import('./views/nova-notificacao/NovaNotificacao.vue')
    },
    {
      path: '/nova-integracao',
      name: 'nova-integracao',
      component: () => import('./views/nova-integracao/NovaIntegracao.vue')
    },
    {
      path: '/radar',
      name: 'radar',
      component: () => import('./views/radar/Radar.vue')
    },
    {
      path: '/santander-emissao',
      name: 'santander-emissao',
      component: () => import('./views/santander-emissao/SantanderEmissao.vue')
    },
    {
      path: '/consulta-cadastro-operadora',
      name: 'consulta-cadastro-operadora',
      component: () => import('./views/consulta-cadastro-operadora/ConsultaCadastroOperadora.vue')
    },
    {
      path: '/chat',
      name: 'chat',
      component: () => import('./views/catalogo-api/Chat.vue')
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/ssv2300-confi-opeda-wss',
      redirect: '/ssv2300-confi-opeda-wss',
      name: 'ssv2300-confi-opeda-ws',
      component: {
        render(c) { return c('router-view'); }
      },
      children: [{
        path: '',
        name: 'ssv2300-confi-opeda-ws-list',
        component: () => import('./views/ssv/Ssv2300ConfiOpedaWsList.vue')
      },
      {
        path: 'new',
        name: 'ssv2300-confi-opeda-ws-new',
        component: () => import('./views/ssv/Ssv2300ConfiOpedaWsNew.vue')
      },
      {
        path: ':id/edit',
        name: 'ssv2300-confi-opeda-ws-edit',
        component: () => import('./views/ssv/Ssv2300ConfiOpedaWsEdit.vue'),
        props: true
      }]
    },
    {
      path: '/ssv2307-usuro-cadtr-crtors',
      redirect: '/ssv2307-usuro-cadtr-crtors',
      name: 'ssv2307-usuro-cadtr-crtor',
      component: {
        render(c) { return c('router-view'); }
      },
      children: [{
        path: '',
        name: 'ssv2307-usuro-cadtr-crtor-list',
        component: () => import('./views/ssv/Ssv2307UsuroCadtrCrtorList.vue')
      },
      {
        path: 'new',
        name: 'ssv2307-usuro-cadtr-crtor-new',
        component: () => import('./views/ssv/Ssv2307UsuroCadtrCrtorNew.vue')
      },
      {
        path: ':id/edit',
        name: 'ssv2307-usuro-cadtr-crtor-edit',
        component: () => import('./views/ssv/Ssv2307UsuroCadtrCrtorEdit.vue'),
        props: true
      }]
    },
    {
      path: '/ssv2308-excec-radar-cotacs',
      redirect: '/ssv2308-excec-radar-cotacs',
      name: 'ssv2308-excec-radar-cotac',
      component: {
        render(c) { return c('router-view'); }
      },
      children: [{
        path: '',
        name: 'ssv2308-excec-radar-cotac-list',
        component: () => import('./views/ssv/Ssv2308ExcecRadarCotacList.vue')
      },
      {
        path: 'new',
        name: 'ssv2308-excec-radar-cotac-new',
        component: () => import('./views/ssv/Ssv2308ExcecRadarCotacNew.vue')
      },
      {
        path: ':id/edit',
        name: 'ssv2308-excec-radar-cotac-edit',
        component: () => import('./views/ssv/Ssv2308ExcecRadarCotacEdit.vue'),
        props: true
      }]
    },
    {
      path: '/ssv2314-cadtr-flag-wss',
      redirect: '/ssv2314-cadtr-flag-wss',
      name: 'ssv2314-cadtr-flag-ws',
      component: {
        render(c) { return c('router-view'); }
      },
      children: [{
        path: '',
        name: 'ssv2314-cadtr-flag-ws-list',
        component: () => import('./views/ssv/Ssv2314CadtrFlagWsList.vue')
      },
      {
        path: 'new',
        name: 'ssv2314-cadtr-flag-ws-new',
        component: () => import('./views/ssv/Ssv2314CadtrFlagWsNew.vue')
      },
      {
        path: ':id/edit',
        name: 'ssv2314-cadtr-flag-ws-edit',
        component: () => import('./views/ssv/Ssv2314CadtrFlagWsEdit.vue'),
        props: true
      }]
    },
    {
      path: '/ssv2340-confi-crtor-wss',
      redirect: '/ssv2340-confi-crtor-wss',
      name: 'ssv2340-confi-crtor-ws',
      component: {
        render(c) { return c('router-view'); }
      },
      children: [{
        path: '',
        name: 'ssv2340-confi-crtor-ws-list',
        component: () => import('./views/ssv/Ssv2340ConfiCrtorWsList.vue')
      },
      {
        path: 'new',
        name: 'ssv2340-confi-crtor-ws-new',
        component: () => import('./views/ssv/Ssv2340ConfiCrtorWsNew.vue')
      },
      {
        path: ':id/edit',
        name: 'ssv2340-confi-crtor-ws-edit',
        component: () => import('./views/ssv/Ssv2340ConfiCrtorWsEdit.vue'),
        props: true
      }]
    },
    {
      path: '/ssv2341-confi-crtor-flag-wss',
      redirect: '/ssv2341-confi-crtor-flag-wss',
      name: 'ssv2341-confi-crtor-flag-ws',
      component: {
        render(c) { return c('router-view'); }
      },
      children: [{
        path: '',
        name: 'ssv2341-confi-crtor-flag-ws-list',
        component: () => import('./views/ssv/Ssv2341ConfiCrtorFlagWsList.vue')
      },
      {
        path: 'new',
        name: 'ssv2341-confi-crtor-flag-ws-new',
        component: () => import('./views/ssv/Ssv2341ConfiCrtorFlagWsNew.vue')
      },
      {
        path: ':id/edit',
        name: 'ssv2341-confi-crtor-flag-ws-edit',
        component: () => import('./views/ssv/Ssv2341ConfiCrtorFlagWsEdit.vue'),
        props: true
      }]
    },
    {
      path: '/ssv2303-confi-auto-fncras',
      redirect: '/ssv2303-confi-auto-fncras',
      name: 'ssv2303-confi-auto-fncra',
      component: {
        render(c) { return c('router-view'); }
      },
      children: [{
        path: '',
        name: 'ssv2303-confi-auto-fncra-list',
        component: () => import('./views/ssv/Ssv2303ConfiAutoFncraList.vue')
      },
      {
        path: 'new',
        name: 'ssv2303-confi-auto-fncra-new',
        component: () => import('./views/ssv/Ssv2303ConfiAutoFncraNew.vue')
      },
      {
        path: ':id/edit',
        name: 'ssv2303-confi-auto-fncra-edit',
        component: () => import('./views/ssv/Ssv2303ConfiAutoFncraEdit.vue'),
        props: true
      }]
    }
  ]
});
